import React from 'react';
import './PrivacyPolicy.css';
import Footer from '../../Footer';

const PrivacyPolicy = () => {
    return (
        <div>
            <div className='container'>
                <div className='privacy-policy'>

                    <h2>Privacy Policy</h2>

                    <h3>Acceptance, Duration, and Account Relationship</h3>
                    <p>
                        By creating an account, booking a service, or otherwise using Pawsible services, you acknowledge and agree to this Privacy Policy.
                    </p>
                    <p>
                        This Privacy Policy remains in effect for as long as you maintain an account with Pawsible, use our services, or until your account is deleted, terminated, or deactivated.
                    </p>
                    <p>
                        Pawsible may update this Privacy Policy at any time. Continued use of services after updates constitutes acceptance of the revised policy.
                    </p>

                    <h3>1. Introduction</h3>
                    <p>
                        This Privacy Policy describes how <strong>Pawsible</strong>, operated by Pixel Perfect, LLC, collects, uses, stores, and shares personal information in connection with our services, website, mobile applications, and operations across all locations.
                    </p>
                    <p>
                        By using our services, you agree to the collection and use of information in accordance with this Privacy Policy.
                    </p>

                    <h3>2. Information We Collect</h3>

                    <h3>2.1 Personal Information</h3>
                    <ul>
                        <li>Name, phone number, email address, and address</li>
                        <li>Emergency contact information</li>
                        <li>Veterinarian information</li>
                        <li>Account login credentials</li>
                    </ul>

                    <h3>2.2 Pet Information</h3>
                    <ul>
                        <li>Pet name, breed, age, weight</li>
                        <li>Vaccination records</li>
                        <li>Medical conditions and medications</li>
                        <li>Behavioral history and notes</li>
                        <li>Feeding and care instructions</li>
                    </ul>

                    <h3>2.3 Transaction & Service Data</h3>
                    <ul>
                        <li>Booking history and service usage</li>
                        <li>Payment transactions and invoices</li>
                        <li>Memberships, packages, and credits</li>
                    </ul>

                    <h3>2.4 Device & Usage Data</h3>
                    <ul>
                        <li>IP address and device information</li>
                        <li>Browser type and usage behavior</li>
                        <li>App interactions and session activity</li>
                    </ul>

                    <h3>2.5 Media Content</h3>
                    <ul>
                        <li>Photos and videos of pets</li>
                        <li>Service-related recordings for safety or documentation</li>
                    </ul>

                    <h3>3. How We Use Information</h3>
                    <ul>
                        <li>Provide and manage services</li>
                        <li>Process payments and transactions</li>
                        <li>Communicate with clients</li>
                        <li>Coordinate care, transport, and partner services</li>
                        <li>Maintain safety, records, and operations</li>
                        <li>Improve services and user experience</li>
                        <li>Send service-related and promotional communications</li>
                    </ul>

                    <h3>4. How We Share Information</h3>
                    <p>We may share information with:</p>
                    <ul>
                        <li>Payment processors (e.g., Stripe)</li>
                        <li>CRM, SMS, and email platforms</li>
                        <li>Cloud hosting and software providers</li>
                        <li>Veterinary clinics and emergency providers</li>
                        <li>Transportation and boarding partners</li>
                        <li>Independent contractors (groomers, trainers)</li>
                        <li>Legal, accounting, and insurance providers</li>
                        <li>Government or regulatory authorities when required</li>
                    </ul>
                    <p>
                        We do not sell personal information for monetary value. However, certain analytics or advertising tools may be considered “sharing” under applicable privacy laws.
                    </p>

                    <h3>5. Cookies, Analytics & Tracking</h3>
                    <p>
                        We may use cookies, analytics tools, and tracking technologies to understand user behavior, improve services, and deliver marketing content.
                    </p>
                    <ul>
                        <li>Website cookies</li>
                        <li>Analytics platforms</li>
                        <li>Advertising pixels</li>
                    </ul>
                    <p>
                        You can control cookies through your browser settings.
                    </p>

                    <h3>6. Payment Information</h3>
                    <p>
                        Payments are processed through secure third-party providers. Pawsible does not store full payment card details on its servers.
                    </p>
                    <p>
                        Payment processors comply with industry security standards such as PCI-DSS.
                    </p>

                    <h3>7. Pet Health & Safety Information</h3>
                    <p>
                        Pet health and behavioral data is collected to ensure safe service delivery. This information may be shared with staff, veterinarians, or partners as necessary for care.
                    </p>

                    <h3>8. Media & Content Use</h3>
                    <p>
                        We may capture photos and videos during services for operational, safety, and marketing purposes.
                    </p>
                    <p>
                        Clients may opt out of marketing-related media use by submitting a written request. This does not apply retroactively to previously published content.
                    </p>

                    <h3>9. Data Retention</h3>
                    <p>
                        We retain information as necessary for business, legal, and operational purposes, including:
                    </p>
                    <ul>
                        <li>Service and transaction records</li>
                        <li>Pet health and vaccination data</li>
                        <li>Incident and safety records</li>
                        <li>Legal and compliance obligations</li>
                    </ul>

                    <h3>10. Your Privacy Rights</h3>
                    <p>Depending on your location, you may have rights to:</p>
                    <ul>
                        <li>Access your personal information</li>
                        <li>Correct inaccurate information</li>
                        <li>Request deletion of your data</li>
                        <li>Request data portability</li>
                        <li>Opt out of certain data uses</li>
                    </ul>
                    <p>
                        Requests may be submitted by contacting us directly.
                    </p>

                    <h3>11. State-Specific Rights</h3>
                    <p>
                        Residents of certain states (including California) may have additional rights under applicable privacy laws, including rights related to data access, deletion, correction, and limitation of use.
                    </p>

                    <h3>12. Children’s Privacy</h3>
                    <p>
                        Our services are not directed to individuals under 13. We do not knowingly collect personal information from children.
                    </p>

                    <h3>13. Data Security</h3>
                    <p>
                        We implement reasonable administrative, technical, and physical safeguards to protect information. However, no system can be guaranteed to be completely secure.
                    </p>

                    <h3>14. Third-Party Links & Services</h3>
                    <p>
                        Our services may link to third-party platforms. We are not responsible for their privacy practices.
                    </p>

                    <h3>15. Changes to This Policy</h3>
                    <p>
                        We may update this Privacy Policy at any time. Updates will be posted with a revised “Last Updated” date.
                    </p>

                    <h3>16. Contact Us</h3>
                    <p>
                        If you have questions or requests regarding this Privacy Policy, please contact:
                    </p>
                    <p>
                        Pawsible / Pixel Perfect, LLC<br/>
                        Email: support@pawsible.com<br/>
                        Address: 555 N Broadway A111, Los Angeles, CA 90012
                    </p>

                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;